// Mock 当前用户 Id
export const mockUserId = window.mockUserId || 'TangSuanKeJi-ChenYao15529246246';

// 可在这里自由 mock wx.invoke 的内容
export const invokeResMock: Record<string, any> = window.invokeResMock || {
  'getCurExternalContact': {
    userId: 'wmxCI8MQAAV3s28pD9jNIEYX7kLWqdxw'
  },
}

// 可在这里自由 wx.fn 的内容
export const wxResMock: Record<string, any> = window.wxResMock || {
  'agentConfig': () => {
    console.log('mock agent config')
  },
}
